import { SourceTransaction } from "../../../../models/data/blobby/source-transaction.data";
import { SourceTransactionStoreModel } from "../../../../models/store/source-transaction.store.model";

type SourceTransactionStoreModelV1 = Omit<SourceTransactionStoreModel, "v" | "rw"> & {
  v: 1;
};

export const sourceTransaction_v0_to_v1 = (
  sourceTransaction: SourceTransaction,
): SourceTransactionStoreModelV1 => {
  return {
    acId: sourceTransaction.accountId,
    sym: sourceTransaction.symbol,
    ccy: sourceTransaction.currency,
    dsc: sourceTransaction.description,
    knd: sourceTransaction.kind,
    dir: sourceTransaction.direction,
    bIB: sourceTransaction.bankImportedBalance,
    qty: sourceTransaction.quantity.actualQuantity.amount.toString(),
    prc: sourceTransaction.price,
    cts: sourceTransaction.categories,
    cls: sourceTransaction.classifications,
    srId: sourceTransaction.sourceId,
    dfn: sourceTransaction.definition,
    tDt: sourceTransaction.transactionDate.dateString,
    v: 1,
    vid: "",
    dc: new Date().toString(),
    dm: new Date().toString(),
    id: sourceTransaction.id,
  };
};

export const sourceTransaction_v1_to_v2 = (
  sourceTransaction: SourceTransactionStoreModel,
): SourceTransactionStoreModel => {
  return {
    ...sourceTransaction,
    rw: "",
    v: 2,
  };
};
